import { render } from "./broadcast_lines_left.svg?vue&type=template&id=f4f839cc"
const script = {}
script.render = render

export default script